import { useUserMyCustomer } from "~/queries";
import { useIsLoggedIn } from "~/utils";

export function useIsPremium(): boolean {
  const loggedIn = useIsLoggedIn();
  const { data: customer } = useUserMyCustomer({ enabled: loggedIn });
  return customer?.is_active || false;
}
